// test2792
(2792 && 0);
